import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import processRealtimeData, { HVAC_MODE } from '../../utilities/ProcessRealtimeZoneHelper';

import './ZoneCard.scss';

const ZoneCard = ({ zoneRealtimeData, selectZone, setZoneHealth }) => {
  const formattedZoneRealtime = processRealtimeData(zoneRealtimeData);
  let hasTemperature = formattedZoneRealtime.currentTemperature !== 'N/A';

  useEffect(() => {
    setZoneHealth(formattedZoneRealtime.zoneStatusCSS);
  }, [zoneRealtimeData]);

  const renderTemperatureSetting = () => {
    if (formattedZoneRealtime.temperatureSetting) {
      const settingClass =
        formattedZoneRealtime.temperatureSetting === HVAC_MODE.COOL_ONLY.label
          ? 'cool-only'
          : formattedZoneRealtime.temperatureSetting === HVAC_MODE.HEAT_ONLY.label
            ? 'heat-only'
            : '';
      return (
        <p className={`setting ${settingClass}`}>{formattedZoneRealtime.temperatureSetting}</p>
      );
    }
    return null;
  };

  return (
    <>
      <tr>
        <td className="location " onClick={selectZone}>
          <div className={'zone-health-indicator ' + formattedZoneRealtime.zoneStatusCSS}></div>
          {zoneRealtimeData && zoneRealtimeData.longThermalZoneDisplayName}
        </td>

        <td className="status">
          <div className={'status ' + formattedZoneRealtime.zoneStatusCSS}>
            {formattedZoneRealtime.zoneStatus}
          </div>
        </td>

        <td className="temp-range">
          {hasTemperature && (
            <div className="zone-thermostat-container">
              <p className="current">{formattedZoneRealtime.currentTemperature}°</p>

              <div>
                <p className="range">
                  {formattedZoneRealtime.temperatureLowerBound !== null &&
                    formattedZoneRealtime.temperatureUpperBound !== null && (
                      <>
                        {formattedZoneRealtime.temperatureLowerBound}° -{' '}
                        {formattedZoneRealtime.temperatureUpperBound}°
                      </>
                    )}
                </p>
                {renderTemperatureSetting()}
              </div>
            </div>
          )}
        </td>

        <td className="schedule">{formattedZoneRealtime.scheduleOrOverride}</td>

        <td className="activity">{formattedZoneRealtime.activityState}</td>

        <td className="keypad">{formattedZoneRealtime.keypadLock}</td>

        <td className="managed">{formattedZoneRealtime.controlState}</td>
      </tr>
    </>
  );
};

export default ZoneCard;
